import { useState } from 'react';

type Sorting = Partial<{
  sortOrder: string;
  sortDirection: string; //'asc' | 'desc'
}>;

export function useTableHeaderSorting(props?: Sorting) {
  const [sortHeader, setSortHeader] = useState<Sorting>({
    sortOrder: props?.sortOrder,
    sortDirection: props?.sortDirection,
  });

  return {
    sortHeader: sortHeader.sortOrder === '' ? undefined : sortHeader,
    setSortHeader,
  };
}
